// extracted by mini-css-extract-plugin
export default {"recos":"O2-z","productCardOverride":"P2-z","rowHasBadge":"Q2-z"};